import React, { useEffect, useState } from 'react';
import { IFreelancer } from '../../data_models/freelancer';
import { IEmployer } from '../../data_models/employer';
import { FilledButton, FlatButton, OutlinedButton, TextButton } from './Button';
import useChat from '../../hooks/useChat';

import useRouting from '../../hooks/useRouting';
import InviteToTasksLightbox from '../lightboxes/projects/InviteToTasksLightbox';
import useTasks from '../../hooks/useTasks';
import ShortlistFreelancerLightbox from '../lightboxes/projects/ShortlistFreelancerLightbox';


interface ChatNowButtonProps {
    user: IFreelancer | IEmployer;
    size?: 'xs' | 'small' | 'medium';
    variant?: 'outlined' | 'filled';
    fullWidth?: boolean;
}

export const ChatNowButton: React.FC<ChatNowButtonProps> = ({ user, size = 'xs', variant = 'outlined', fullWidth = false }) => {

    const { setActiveConversationByPartner } = useChat();
    const { goToChat } = useRouting();
    const [isLoading, setIsLoading] = useState(false);

    const onChatNow = async () => {
        setIsLoading(true);
        await setActiveConversationByPartner(user);
        goToChat();
        setIsLoading(false);
    }
    return (
        <div>
            {variant === 'outlined' ? (
                <OutlinedButton
                size={size}
                fullWidth={fullWidth}
                onClick={onChatNow}
                isLoading={isLoading}
            >Message</OutlinedButton>
            ) : (
                <FilledButton
                    size={size}
                    fullWidth={fullWidth}
                    onClick={onChatNow}
                    isLoading={isLoading}
                >Message</FilledButton>
            )}
        </div>
    );
};

interface InviteForTasksButtonProps {
    freelancer: IFreelancer;
    size?: 'xs' | 'small' | 'medium';
    fullWidth?: boolean;
    variant?: 'outlined' | 'filled';
}
export const InviteForTasksButton: React.FC<InviteForTasksButtonProps> = ({ freelancer, size = 'xs', fullWidth = false, variant = 'outlined' }) => {

    const [showInviteToTaskLightbox, setShowInviteToTaskLightbox] = useState(false);
    return (
        <div>
            {variant === 'outlined' ? (
                <OutlinedButton
                    size={size}
                    fullWidth={fullWidth}
                    onClick={() => {
                        setShowInviteToTaskLightbox(true);
                    }}>Offer a Task</OutlinedButton>
            ) : (
                <FilledButton
                    size={size}
                    fullWidth={fullWidth}
                    onClick={() => {
                        setShowInviteToTaskLightbox(true);
                    }}>Offer a Task</FilledButton>
            )}

            {/* lightbox */}
            {showInviteToTaskLightbox && <InviteToTasksLightbox
                onClose={() => { setShowInviteToTaskLightbox(false) }}
                freelancer={freelancer} />}
        </div>
    );
}

interface ShortlistFreelancerButtonProps {
    freelancer: IFreelancer;
    size?: 'xs' | 'small' | 'medium';
    fullWidth?: boolean;
    variant?: 'outlined' | 'filled';
}
export const ShortlistFreelancerButton: React.FC<ShortlistFreelancerButtonProps> = ({ freelancer, size = 'xs', fullWidth = false, variant = 'outlined' }) => {

    const [showShortlistFreelancerLightbox, setShowShortlistFreelancerLightbox] = useState(false);

    return (
        <div>
            {variant === 'outlined' ? (
                <OutlinedButton
                    size={size}
                    fullWidth={fullWidth}
                    onClick={() => {
                        setShowShortlistFreelancerLightbox(true);
                    }}>Shortlist</OutlinedButton>
            ) : (
                <FilledButton
                    size={size}
                    fullWidth={fullWidth}
                    onClick={() => {
                        setShowShortlistFreelancerLightbox(true);
                    }}>Shortlist</FilledButton>
            )}

            {showShortlistFreelancerLightbox && <ShortlistFreelancerLightbox
                onClose={() => { setShowShortlistFreelancerLightbox(false) }}
                freelancer={freelancer} />}
        </div>
    );
}